import { render, staticRenderFns } from "./PlayerFooter.vue?vue&type=template&id=676c0252&scoped=true"
import script from "./PlayerFooter.vue?vue&type=script&lang=js"
export * from "./PlayerFooter.vue?vue&type=script&lang=js"
import style0 from "./PlayerFooter.vue?vue&type=style&index=0&id=676c0252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676c0252",
  null
  
)

export default component.exports